interface SingleArrayDataProps<T> {
  data: T[];
  key: keyof T;
}

/**
 * Extrae valores únicos de un array de objetos basándose en una clave específica
 * Los valores se ordenan alfabéticamente y solo incluye valores string válidos
 *
 * @template T - Tipo del objeto en el array
 * @param params - Objeto de configuración
 * @param params.data - Array de objetos del cual extraer valores únicos
 * @param params.key - Clave del objeto de la cual extraer valores
 * @returns Array de valores únicos ordenados alfabéticamente
 * @example
 * const students = [
 *   { name: 'Juan', career: 'Ingeniería' },
 *   { name: 'María', career: 'Medicina' },
 *   { name: 'Pedro', career: 'Ingeniería' }
 * ];
 * singleArrayData({ data: students, key: 'career' })
 * // ['Ingeniería', 'Medicina']
 */
export const singleArrayData = <T>({ data, key }: SingleArrayDataProps<T>) => {
  const uniqueSet = new Set<string>();

  for (const item of data) {
    const value = item[key];
    if (value && typeof value === 'string') {
      uniqueSet.add(value);
    }
  }

  return Array.from(uniqueSet).sort();
};
